import { render } from "./HorseEditOwners.vue?vue&type=template&id=2f2d8ecc"
import script from "./HorseEditOwners.vue?vue&type=script&lang=js"
export * from "./HorseEditOwners.vue?vue&type=script&lang=js"

import "./HorseEditOwners.vue?vue&type=style&index=0&id=2f2d8ecc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__